export default __webpack_public_path__ + "static/media/Cellulitis-1.299f4afc.jpg";